import { Placeholder, Table } from 'semantic-ui-react'

const MoreLoader = ({ columns }: { columns: Array<{ key: string }> }) => {
  const rows: Array<{
    key: number
  }> = Array.from(Array(20).keys()).map(key => ({
    key,
  }))

  return (
    <>
      {rows.map(({ key }) => (
        <Table.Row key={key}>
          {columns.map(column => (
            <Table.Cell key={column.key} style={{ padding: '2em 1em' }}>
              <Placeholder>
                <Placeholder.Paragraph>
                  <Placeholder.Line />
                </Placeholder.Paragraph>
              </Placeholder>
            </Table.Cell>
          ))}
        </Table.Row>
      ))}
    </>
  )
}

export default MoreLoader
